import * as React from "react";
import { inject, observer } from "mobx-react";
import ModelStore from "src/stores/ModelStore";
import "./ProductInfoComponent.scss";
interface IProps {
  modelStore?: ModelStore;
}
@inject("modelStore")
@observer
export default class ProductInfoComponent extends React.Component<IProps, {}> {
  
    public render(){
        const modelStore = this.props.modelStore as ModelStore;
        if(modelStore.selectedModel === null){
            return (<div/>);
        }else{
            return (
                <div className="product-infos col-xs-12 col-md-3 col-lg-3">
                    <div className="scroll-box" dangerouslySetInnerHTML={this._createMarkup()} /> 
                    <div className="contact-infos">
                        <h2>Wir beraten Sie gerne!</h2>
                        <img src="/assets/konfigurator/Katrin_Spieker_Konfigurator.jpg" /> 
                        <a className="button" href="tel:+492355-92900">02355-92900</a>
                    </div>
                </div>

            );
        }
    }

  private _createMarkup(){
    const modelStore = this.props.modelStore as ModelStore;
    return {__html: modelStore.sideBarText };
  }  


}


// WEBPACK FOOTER //
// ./src/components/ProductInfoComponent.tsx